module.exports = __webpack_public_path__ + "img/bg-servicos.afdf2103.svg";